<template>
  <modal :show-on-mount="true" :click-outside-to-close="false" :headerless="true"
         size="sm" modal-id="confirm-your-email-modal">
    <template #body>
      <div class="text-center">
        <h2 class="mt-3 title">
          {{ i18n.t('public.confirm_your_email_modal.title') }}
        </h2>
        <p>
          <span>
            {{ emailSentMessage }}
          </span>

          <span v-if="warningMessage" class="text-danger">
            {{ warningMessage }}
          </span>
        </p>
        <p v-if="emailAddress">
          <span class="d-block">{{ i18n.t('public.confirm_your_email_modal.sent_to') }}</span>
          <strong>{{ emailAddress }}</strong>
        </p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../components/modal'

export default {
  components: { Modal },

  props: {
    emailAddress: {
      type: String,
      required: false
    },

    emailSentMessage: {
      type: String,
      required: true
    },

    warningMessage: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 32px;
  font-weight: 500;
}
</style>
